module.exports = __webpack_public_path__ + "assets/img/homepage.86dc9c58.jpg";